import { render, staticRenderFns } from "./AffiliationCardList.vue?vue&type=template&id=aa7e2f48"
import script from "./AffiliationCardList.vue?vue&type=script&lang=js"
export * from "./AffiliationCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports